import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AsyncDropdown } from '@ami/react/core';
import { CouplerStyle } from '@ami/react/shared';
import { CouplerStyleFilter } from '@ami/react/shared';
import { CouplerTypes } from '@ami/react/shared';
import { CouplerStyleTypes } from '@ami/react/shared';

export default class CouplerStylesAsyncDropdown extends Component {
  constructor(props) {
    super(props);
    this.fetchItems = this.fetchItems.bind(this);
  }

  static propTypes = {
    placeholder: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    carrierId: PropTypes.string,
    weightCategoryId: PropTypes.string,
    selected: PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  };
  async fetchItems(name) {
    if (!name) {
      return [];
    }
    const { carrierId, weightCategoryId } = this.props;
    return await CouplerStyle.search(
      new CouplerStyleFilter({
        search: name,
        carrierId: carrierId,
        weightCategoryId: weightCategoryId,
      }),
      0
    );
  }

  mapAsyncContentItem(item) {
    return {
      id: item.id,
      label: item.name,
      couplerType: item.couplerType,
      description: `${CouplerTypes[item.type]} / ${CouplerStyleTypes[item.style]} / ${item.carrierName} ${item.weightCategoryName}`,
    };
  }

  render() {
    const { ...rest } = this.props;
    return (
      <AsyncDropdown
        placeholder={this.props.placeholder || 'All'}
        isClearable={true}
        fetchItems={this.fetchItems}
        prepopulateFromStorage={true}
        mapItemsToDropdownItems={(items) => {
          return items.map((x) => this.mapAsyncContentItem(x));
        }}
        {...rest}
      />
    );
  }
}
